import PropTypes from 'prop-types';

export default PropTypes.shape({
  license: PropTypes.string.isRequired,
  licenseBy: PropTypes.string.isRequired,
});
